{
  "schemaVersion": 1,
  "slug": "anthropic",
  "name": "Anthropic",
  "description": "Use Anthropic APIs with a restricted key.",
  "categories": [
    "ai"
  ],
  "featured": false,
  "branding": {
    "logoUrl": "/brands/apps/anthropic.svg",
    "darkLogoUrl": "/brands/apps/anthropic-dark.svg"
  },
  "urlPatterns": [
    "https://api.anthropic.com/*"
  ],
  "methods": [
    {
      "key": "ai-subscription",
      "label": "Claude subscription",
      "purpose": "ai",
      "transport": "runtime_auth",
      "auth": "oauth",
      "ai": {
        "provider": "anthropic",
        "method": "subscription"
      },
      "grantKinds": [
        "user",
        "organization"
      ],
      "ownershipModes": [
        "customer"
      ],
      "whenToUse": "Authenticate an agent with this account.",
      "guidanceMd": "Use your personal account or an explicitly shared company account.",
      "riskTier": "S3"
    },
    {
      "key": "ai-api_key",
      "label": "Claude API key",
      "purpose": "ai",
      "transport": "runtime_auth",
      "auth": "api_key",
      "ai": {
        "provider": "anthropic",
        "method": "api_key"
      },
      "grantKinds": [
        "user",
        "organization"
      ],
      "ownershipModes": [
        "customer"
      ],
      "whenToUse": "Authenticate an agent with this account.",
      "guidanceMd": "Use your personal account or an explicitly shared company account.",
      "riskTier": "S3",
      "credentialFields": [
        {
          "key": "apiKey",
          "label": "API key",
          "type": "password",
          "required": true,
          "placeholder": "Enter API key",
          "secret": true
        }
      ],
      "keyPlacement": {
        "location": "env",
        "name": "ANTHROPIC_API_KEY"
      }
    }
  ]
}
